import { React, useEffect, useState } from "react";

//ANT DESIGN IMPORTS
import { Input, Row, Typography, Form, Tooltip, Col, Select, InputNumber, Divider } from "antd";

//ANT DESIGN ICONS IMPORTS
import { labelConfig, staticConfig } from "../../../../customer.config";

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import styles from "../../../../../../assets/styles/styles";

const { Text, Title } = Typography;

const TermsForm = (props) => {
  const [isRequired, setIsRequired] = useState(null);
  const {
    onFinish,
    form,
    initialValues,
    interestCompoundingPeriodTypeOptions,
    interestPostingPeriodTypeOptions,
    interestCalculationTypeOptions,
    interestCalculationDaysInYearTypeOptions,
    lockinPeriodFrequencyTypeOptions,
  } = props;

  useEffect(() => {}, []);

  const onChange = (value) => {
    setIsRequired(value);
  };
  const isAllowOverdraft = Form.useWatch("allowOverdraft", form);
  const isLienAllowed = Form.useWatch("lienAllowed", form);

  return (
    <Form layout="vertical" onFinish={onFinish} form={form} initialValues={initialValues}>
      <Row>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.interestInfo}
          </Title>
        </Divider>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.interestCompoundingPeriod}
            name="interestCompoundingPeriodType"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.interestCompoundingPeriod),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.interestCompoundingPeriod,
                "select"
              )}
              options={interestCompoundingPeriodTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.interestPostingPeriod}
            name="interestPostingPeriodType"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.interestPostingPeriod),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              placeholder={BOM.handlePlaceholderMsg(labelConfig.interestPostingPeriod, "select")}
              options={interestPostingPeriodTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.interestCalculatedUsing}
            name="interestCalculationType"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.interestCalculatedUsing),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              placeholder={BOM.handlePlaceholderMsg(labelConfig.interestCalculatedUsing, "select")}
              options={interestCalculationTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.overdraftInfo}
          </Title>
        </Divider>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={
              <Tooltip title={labelConfig.maxOverdraftAmountLimit}>
                {BOM.SubstringFormat(labelConfig.maxOverdraftAmountLimit, 20)}
              </Tooltip>
            }
            name="overdraftLimit"
          >
            <InputNumber
              min={0}
              style={{ width: "100%", ...styles.ofInputFieldNumber }}
              placeholder={BOM.handlePlaceholderMsg(labelConfig.maxOverdraftAmountLimit)}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={
              <Tooltip title={labelConfig.nominalAnnualInterestForOverdraft}>
                {BOM.SubstringFormat(labelConfig.nominalAnnualInterestForOverdraft, 20)}
              </Tooltip>
            }
            name="nominalAnnualInterestRateOverdraft"
          >
            <Input
              placeholder={BOM.handlePlaceholderMsg(labelConfig.nominalAnnualInterestForOverdraft)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={
              <Tooltip title={labelConfig.minOverdraftRequiredForInterestCalculation}>
                {BOM.SubstringFormat(labelConfig.minOverdraftRequiredForInterestCalculation, 20)}
              </Tooltip>
            }
            name="minOverdraftForInterestCalculation"
          >
            <InputNumber
              style={{ width: "100%" }}
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.minOverdraftRequiredForInterestCalculation
              )}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
            />
          </Form.Item>
        </Col>

        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.additionalInfo}
          </Title>
        </Divider>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.norminalAnnualInterest}
            name="nominalAnnualInterestRate"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.norminalAnnualInterest),
              },
            ]}
          >
            <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.norminalAnnualInterest)} />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.daysInYear}
            name="interestCalculationDaysInYearType"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.daysInYear),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              placeholder={BOM.handlePlaceholderMsg(labelConfig.daysInYear, "select")}
              options={interestCalculationDaysInYearTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={labelConfig.minimumOpeningBalance} name="minRequiredOpeningBalance">
            <InputNumber
              style={{ width: "100%" }}
              placeholder={BOM.handlePlaceholderMsg(labelConfig.minimumOpeningBalance)}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={labelConfig.lockInPeriod} name="lockinPeriodFrequency">
            <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.lockInPeriod)} />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.lockinPeriodFrequencyType}
            name={"lockinPeriodFrequencyType"}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              showSearch
              allowClear
              options={lockinPeriodFrequencyTypeOptions}
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.lockinPeriodFrequencyType,
                "select"
              )}
            />
          </Form.Item>
        </Col>

        {/* <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={labelConfig.isLienAllowed} name="lienAllowed">
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.isLienAllowed,
                "select"
              )}
              options={staticConfig.yesOrNoData}
              showSearch
              value={isLienAllowed}
              onChange={onChange}
            />
          </Form.Item>
        </Col>
        {isLienAllowed && (
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.maximumLienAmountLimit}
              name="maxAllowedLienLimit"
              rules={[
                {
                  required: isRequired,
                  message: BOM.CheckReqFld(labelConfig.maximumLienAmountLimit),
                },
              ]}
            >
              <Input
                placeholder={BOM.handlePlaceholderMsg(
                  labelConfig.maximumLienAmountLimit
                )}
              />
            </Form.Item>
          </Col>
        )} */}

        {!isAllowOverdraft && (
          <>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.enforceMinimumBalance} name="enforceMinRequiredBalance">
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.enforceMinimumBalance,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={6} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.minimumBalance} name="minRequiredBalance">
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.minimumBalance)}
                  formatter={BOM.FormatAmount}
                  parser={BOM.ParseAmount}
                />
              </Form.Item>
            </Col>
            <Col span={10} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.applyWithdrawalFeeForTransfers}
                name="withdrawalFeeForTransfers"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.applyWithdrawalFeeForTransfers,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />
              </Form.Item>
            </Col>
          </>
        )}
      </Row>
    </Form>
  );
};

export default TermsForm;
